import { useSeo } from "../lib/seo";
import { Logo, LogoMark } from "../components/Logo";
import { PageFade } from "../components/Motion";

const Tile = ({ label, bg, children, testid }) => (
  <div className="border border-navy/10" data-testid={testid}>
    <div className={`grid place-items-center h-56 ${bg}`}>{children}</div>
    <p className="px-4 py-3 text-xs font-mono tracking-wider text-mist bg-white">{label}</p>
  </div>
);

export default function Brand() {
  useSeo("Brand Assets", "Sido Holdings logo versions.");
  return (
    <PageFade>
      <section className="bg-paper pt-[140px] pb-24">
        <div className="container-x">
          <p className="eyebrow">Brand Assets</p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-medium text-navy">The Sido Holdings mark.</h1>
          <p className="mt-4 max-w-2xl text-ink/70">A geometric “S” built from architectural blocks, with a restrained gold step signaling upward value. Designed for websites, business cards, documents, presentations, signage and social.</p>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            <Tile label="PRIMARY · DARK ON LIGHT" bg="bg-paper" testid="brand-dark"><Logo tone="dark" testid="brand-logo-dark" /></Tile>
            <Tile label="WHITE · ON NAVY" bg="bg-navy" testid="brand-white"><Logo tone="light" testid="brand-logo-white" /></Tile>
            <Tile label="ICON ONLY" bg="bg-white" testid="brand-icon"><LogoMark className="h-20 w-20" /></Tile>
            <Tile label="FAVICON / APP ICON" bg="bg-[#EDECE6]" testid="brand-favicon"><LogoMark boxed tone="light" className="h-16 w-16" /></Tile>
          </div>
          <div className="mt-12 grid grid-cols-5 gap-2 max-w-xl">
            {[["#0B1726", "Deep Navy"], ["#111827", "Charcoal"], ["#F7F7F4", "Off White"], ["#C5A46D", "Warm Gold"], ["#6B7280", "Soft Gray"]].map(([c, n]) => (
              <div key={c}><div className="h-16 border border-navy/10" style={{ background: c }} /><p className="mt-2 text-[11px] text-navy">{n}</p><p className="font-mono text-[10px] text-mist">{c}</p></div>
            ))}
          </div>
        </div>
      </section>
    </PageFade>
  );
}
